import React, { useLayoutEffect, useState } from "react";
import { Link, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import PageEventManager from "../pages/eventManager";
import PageAddNewParticipant from "../pages/addNewParticipant";
import styles from "../styles/EventManagerLayout.module.scss";
import EventNavbar from "../components/EventNavigationBar";
import { Axios } from "../App";
import TitleWithBack from "../components/titleWithBack";

type TEventDesign = {
  name: string;
  logo: string;
  background_color: string;
  font_color: string;
};

const EventManagerLayout = (): JSX.Element => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [eventDesign, setEventDesign] = useState<TEventDesign>();

  const isEventExists = async () => {
    try {
      const { data } = await Axios.post("events/isEventExists.php", {
        id: id,
      });
      if (!data?.isExists) navigate("/");
    } catch (e) {
      console.error(e);
    }
  };

  const getEventData = async () => {
    return await Axios.post("events/getEventData.php", { id: id }).then(
      ({ data }) => {
        setEventDesign(data);
      }
    );
  };

  useLayoutEffect(() => {
    const getQueries = async () => {
      await isEventExists();
      await getEventData();
    };

    getQueries();
  }, []);

  return (
    <section style={{ backgroundColor: eventDesign?.background_color
      ? eventDesign?.background_color
      : "#0A1929", minHeight:"100vh" }}>
      <EventNavbar />
      <div className={styles.layoutInnerWrapper}>
        {pathname.split('/')[2] != 'event-manager' && 
          <Link to={`/${id}/event-manager`}>
            {'<< Vissza a táblázathoz'}
          </Link>
        }
        <TitleWithBack title={eventDesign?.name} fontColor={eventDesign?.font_color} />
        <Routes>
          <Route
            path="/event-manager"
            element={
              <PageEventManager
                logoFromDB={eventDesign?.logo}
                fontColor={eventDesign?.font_color}
              />
            }
          />
          <Route
            path="/add-new-participant"
            element={
              <PageAddNewParticipant
                fontColor={eventDesign?.font_color}
              />
            }
          />
        </Routes>
      </div>
    </section>
  );
};

export default React.memo(EventManagerLayout);
